"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicText = exports.getPublicTexts = exports.deleteTextRelation = exports.postTextRelation = exports.putTextOrganization = exports.putTextAccessibility = exports.deleteTextPermission = exports.postTextPermission = exports.delText = exports.postText = exports.putText = exports.getText = exports.getTexts = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var textsAuthorizedPath = root_1.cmsAuthorized + '/texts/';
var textsPublicPath = root_1.cmsPublic + '/texts/';

var getTexts = function getTexts(authentication, queryParameters) {
  return common_1.get(authentication, textsAuthorizedPath, queryParameters);
};

exports.getTexts = getTexts;

var getText = function getText(authentication, id) {
  return common_1.get(authentication, textsAuthorizedPath + id);
};

exports.getText = getText;

var putText = function putText(authentication, text) {
  return common_1.put(authentication, textsAuthorizedPath + text.id, text);
};

exports.putText = putText;

var postText = function postText(authentication, text) {
  return common_1.post(authentication, textsAuthorizedPath, text);
};

exports.postText = postText;

var delText = function delText(authentication, id) {
  return common_1.del(authentication, textsAuthorizedPath + id);
};

exports.delText = delText;

var postTextPermission = function postTextPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, textsAuthorizedPath, id, permission);
};

exports.postTextPermission = postTextPermission;

var deleteTextPermission = function deleteTextPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, textsAuthorizedPath, id, permissionId);
};

exports.deleteTextPermission = deleteTextPermission;

var putTextAccessibility = function putTextAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, textsAuthorizedPath, id, accessibility);
};

exports.putTextAccessibility = putTextAccessibility;

var putTextOrganization = function putTextOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, textsAuthorizedPath, id, organizationId);
};

exports.putTextOrganization = putTextOrganization;

var postTextRelation = function postTextRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, textsAuthorizedPath, id, relation);
};

exports.postTextRelation = postTextRelation;

var deleteTextRelation = function deleteTextRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, textsAuthorizedPath, id, relationId);
};

exports.deleteTextRelation = deleteTextRelation;

var getPublicTexts = function getPublicTexts(authentication, queryParameters) {
  return common_1.get(authentication, textsPublicPath, queryParameters);
};

exports.getPublicTexts = getPublicTexts;

var getPublicText = function getPublicText(authentication, id) {
  return common_1.get(authentication, textsPublicPath + id);
};

exports.getPublicText = getPublicText;